export default "__VITE_ASSET__BPxaVr33__"